import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      scaleY={1}
      scaleX={1}
      width={81}
      height={14}
      viewBox="0 0 81 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M6.44 13.41a6.4 6.4 0 01-4.55-1.826 6.293 6.293 0 010-8.999A6.399 6.399 0 016.44.76v3.239c-.823 0-1.612.325-2.195.904a3.076 3.076 0 000 4.363 3.114 3.114 0 002.196.904v3.24zM50.613 5.282v8.128h-3.72V5.323h-.005a.83.83 0 00-.24-.59.839.839 0 00-1.433.573v.017h-.007v8.088h-3.72V5.293v-.028.028h-.006a.829.829 0 00-.245-.588.839.839 0 00-1.427.588h-.007v8.117h-3.717V5.268c.001-.84.238-1.663.682-2.377a4.552 4.552 0 011.835-1.668 4.587 4.587 0 014.767.414 4.58 4.58 0 016.555 1.276 4.515 4.515 0 01.688 2.37zM71.284 9.713v3.697h-6.975V.759h3.72v8.954h3.255zM22.335.768v3.697h-1.942v8.947h-3.72V4.466h-1.969V.768h7.63zM20.393.758h-3.719v.006h3.72V.758zM33.768 1.039v4.044a4.515 4.515 0 01-.757 2.455 4.555 4.555 0 01-1.977 1.652v4.221h-3.72v-4.25a4.555 4.555 0 01-1.932-1.653 4.514 4.514 0 01-.738-2.425V1.039h3.72v4.015h.005v.017a.827.827 0 00.52.778.84.84 0 001.097-.471.826.826 0 00.055-.324h.008V1.039h3.719zM12.422.759h-3.72v12.65h3.72V.76zM80.567 9.713v3.697h-6.975V.759h3.72v8.954h3.255zM61.993 5.269A4.52 4.52 0 0060.64 2.09 4.576 4.576 0 0057.43.78a4.577 4.577 0 00-3.21 1.313 4.52 4.52 0 00-1.352 3.177v8.147h3.72v-2.662h1.685v2.658h3.72V5.283l-.001-.014zm-3.72 1.79h-1.685V5.324h.007c0-.22.088-.432.245-.587a.84.84 0 011.428.587h.006V7.06z"
        fill="#E40046"
      />
    </Svg>
  );
}

export default SvgComponent;
